import { BundlePaymentPlan, BundleType, MyBundleStatus } from 'multirpc-sdk';

export interface GetCreditsLimitParams {
  bundleStatus: MyBundleStatus;
  plans: BundlePaymentPlan[] | undefined;
}

export const getCreditsLimit = ({
  bundleStatus,
  plans,
}: GetCreditsLimitParams) => {
  const plan = plans?.find(
    ({ bundle }) => bundle.bundle_id === bundleStatus.bundleId,
  );

  const creditsLimit =
    plan?.bundle.limits.find(({ type }) => type === BundleType.COST)?.limit ||
    0;

  return creditsLimit;
};
